import React from "react";
import propTypes from "prop-types";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import BaseButton from "./Button.base";

const style = {
  root: {
    width: "180px",
    margin: "20px"
  }
};

const NavButton = ({ label, href, disabled, classes }) => (
  <BaseButton
    component={Link}
    to={href}
    label={label}
    disabled={disabled}
    variant="outlined"
    classes={{
      root: classes.root
    }}
  />
);

NavButton.propTypes = {
  label: propTypes.string.isRequired,
  href: propTypes.string.isRequired,
  disabled: propTypes.bool.isRequired
};

export default withStyles(style)(NavButton);
